"use client";

// Registra el service worker en TODA la app (antes solo pasaba si el usuario
// entraba a /perfil, así que la PWA no era instalable desde el resto de las pantallas).
import { useEffect } from "react";

export default function ServiceWorkerRegister() {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  }, []);
  return null;
}
